/** Calendar month key utilities (YYYY-MM), timezone-safe for month arithmetic. */

/** Format a YYYY-MM key from a calendar year and 0-based month index. */
export function formatMonthKey(year: number, monthIndex0: number): string {
  return `${year}-${String(monthIndex0 + 1).padStart(2, '0')}`
}

/** Parse a YYYY-MM key into year and 0-based month index. */
export function parseMonthKey(key: string): { year: number; monthIndex0: number } {
  const [yearStr, monthStr] = key.split('-')
  return {
    year: Number(yearStr),
    monthIndex0: Number(monthStr) - 1,
  }
}

/** Extract the YYYY-MM month key from an ISO date string (YYYY-MM-DD). */
export function monthKeyFromDateString(dateStr: string): string {
  return dateStr.slice(0, 7)
}

/** Return true when month key a is the same as or before month key b. */
export function isSameOrBeforeMonth(a: string, b: string): boolean {
  return a <= b
}

/** Return true when month key a is strictly before month key b. */
export function isBeforeMonth(a: string, b: string): boolean {
  return a < b
}

/** Add or subtract calendar months from a YYYY-MM key. */
export function stepMonthKey(key: string, delta: number): string {
  const { year, monthIndex0 } = parseMonthKey(key)
  const d = new Date(year, monthIndex0 + delta, 1)
  return formatMonthKey(d.getFullYear(), d.getMonth())
}

/** Build Jan–Dec skeleton keys for a calendar year. */
export function buildYearMonthSkeleton(year: number): string[] {
  return Array.from({ length: 12 }, (_, mo) => formatMonthKey(year, mo))
}
